export default class ResponseParseError extends Error {
  response: Response;
  status: number;
  url: string;

  constructor(response: Response, cause: unknown) {
    super(`Failed to parse response from ${response.url}`, { cause });
    this.name = 'ResponseParseError';
    this.response = response;
    this.status = response.status;
    this.url = response.url;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ResponseParseError);
    }
  }
}
